import { UserAvatar } from './UserAvatar'

export default UserAvatar